import {Component, OnInit} from '@angular/core';
import {CalcResponseModel} from '../../models/calc-response.model';
import {FileURL} from '../../models/FileURL.model';
import {UserResponseModel} from '../../models/user-response.model';
import {UserRequestModel} from '../../models/user-request.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CalcApiService} from '../../services/calc-api.service';
import {Router} from '@angular/router';
import {StorageHelperService} from '../../services/storage-helper.service';
import {SharedService} from '../../services/shared.service';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import { TokenManager } from '../../services/TokenManager';


@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.less']
})
export class Step1Component implements OnInit {

  userResponseModel: UserResponseModel = new UserResponseModel();
  userRequestModel: UserRequestModel = new UserRequestModel();
  loader = false;
  userForm: FormGroup;
  type: string;

  constructor(private webShopApiService: CalcApiService, private router: Router, private fb: FormBuilder,
     private authenticationService: SharedService,  private tokenManager: TokenManager,
    private toasterService: ToasterService) {

    this.userForm = fb.group({
      'user': [null, Validators.compose([Validators.required])],
   //   'pass': [null]
    });
  }

  ngOnInit() {
    sessionStorage.clear();
  }


  submitCalc() {

    if (this.userForm.controls['user'].value.length > 4)
    {
    this.loader = true;



    this.userRequestModel.userName =  this.userForm.controls['user'].value;
  //  this.userRequestModel.pasWord =  this.userForm.controls['pass'].value;

    this.webShopApiService.userCheck(this.userRequestModel)
      .subscribe(
        (response) => {
          this.userResponseModel = new UserResponseModel();
          this.userResponseModel = response;

            if(this.userResponseModel.active === 1) {
              // this.authenticationService.login(this.userResponseModel);

              localStorage.setItem('currentUser', JSON.stringify(this.userResponseModel));

         //     this.router.navigate(['LogACod'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

              this.tokenManager.generateNewToken(this.userResponseModel);
              this.authenticationService.login(this.userResponseModel);
              StorageHelperService.PushData('userResponseModel', this.userResponseModel);
              this.router.navigate(['homemenu'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });
            } else {
              const toast: Toast = {
                type: 'error',
                title: 'Greška',
                body: 'Proverite korisničko ime i probajte ponovo!',
                showCloseButton: true
              };
              this.toasterService.pop(toast);
            }

          this.loader = false;
        },
        (error) => {
          console.log(error);
          const toast: Toast = {
            type: 'error',
            title: 'Greška',
            body: 'Proverite korisničko ime i probajte ponovo!',
            showCloseButton: true
          };
          this.toasterService.pop(toast);
          this.loader = false;

        }
      );
    }

             // this.router.navigate(['LogACod'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


}



// WEBPACK FOOTER //
// ./src/app/pages/LoginUP/step1.component.ts